import React, {useState, useEffect} from 'react'
import { useParams } from 'react-router-dom';
import './ContainerViewer.css';
import Swal from 'sweetalert2'
import GetReCaptchaToken from '../reCAPTCHA.js';
import ContainerViewer from './ContainerViewer.jsx';

export default function ContainerViewerNoAccess(props) {
    const [depotName, setDepotName] = useState("Loading...");
    let {locationGUID} = useParams();
    const [authed, setAuthed] = useState(false);

    useEffect(()=> {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(`/manned/${locationGUID}`, requestOptions).then(res => {
            return res.json()
        }).then(res=> {
            setDepotName(res.name);
        })
    })

    async function CheckPassword(password) {

        let token = await GetReCaptchaToken();

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ depotGuid: locationGUID, password: password, token: token})
        };

        let response = await (await fetch('/NoTokenDepotAccess', requestOptions)).json();
        
        if (response.successful) {
            setAuthed(true);
        }
        else {
            Swal.fire({
                title: 'Error',
                text: response.data,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }

    return (
        <div className='ContainerViewer w-100'>
            <div className="Header w-100 bg-main">
                <img src="/assets/img/abclong.svg" alt="ABC Container Hire and Sales Logo" className='Logo'/>
            </div>
            <div className="Page-Content w-90">
                <div className="w-100 text-center">
                    <h2 className='no-block-end'>Container Viewer</h2>
                    <h3 className='no-block-start color-main'>{depotName}</h3>
                </div>
                <div className="w-90 text-center col align-center justify-center">
                    {
                        authed === true ?
                        <ContainerViewer GUID={locationGUID}></ContainerViewer>
                        :
                        <div>
                            <input type="text" placeholder='Access Code' id="no_access_password" /> <br /><br />
                            <button className="Button" onClick={e=>CheckPassword(document.getElementById("no_access_password").value)}>Submit</button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
